
const companyData = {
  columns: [
    { Header: "name", accessor: "name", width: "20%" },
    { Header: "type", accessor: "type", width: "25%" },
    { Header: "trader payment information", accessor: "paymentInfo" },
    { Header: "status", accessor: "status", width: "7%" },
    { Header: "financial standing", accessor: "standing" },
    { Header: "# of Employees", accessor: "employees" },
    { Header: "office type", accessor: "officeType", width: "20%" },
    { Header: "legal entity type", accessor: "entityType", width: "25%" },
    { Header: "company executives", accessor: "execs" },
    { Header: "date of establishment", accessor: "date", width: "7%" },
    { Header: "address", accessor: "address" },
  ],

  rows: [
    {
      name: "ShockWave Medical Inc",
      type: "45518 ",
      paymentInfo: "true",
      status: "active",
      standing: "$1,116,575",
      employees: "138",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Yulie Ips",
      date: "06/17/2012",
      address: "56 W. 14th St New York, NY"
    },
    {
      name: "Halozyme Therapeutics Inc",
      type: "541",
      paymentInfo: "true",
      status: "active",
      standing: "$15,847,658",
      employees: "16,458",
      officeType: "S-CORP",
      entityType: "S-CORP",
      execs: "Leah Ghoes",
      date: "01/08/1934",
      address: "4 W. 56th St New York, NY"
    },
    {
      name: "EMCOR Group Inc",
      type: "64278 ",
      paymentInfo: "true",
      status: "active",
      standing: "$987,362",
      employees: "32",
      officeType: "C-CORP",
      entityType: "C-CORP",
      execs: "Geogr Clims",
      date: "05/13/2004",
      address: "785 W. 13th St New York, NY"
    },
    {
      name: "Matador Resources Co",
      type: "58027",
      paymentInfo: "true",
      status: "active",
      standing: "$1,280,238",
      employees: "147",
      officeType: "LLC",
      entityType: "LLC",
      execs: "June Evens",
      date: "01/08/1934",
      address: "A4 W. 67th St New York, NY"
    },
    {
      name: "Karuna Therapeutics Inc",
      type: "83279",
      paymentInfo: "true",
      status: "active",
      standing: "$23,050,560",
      employees: "174,534",
      officeType: "C-CORP",
      entityType: "C-CORP",
      execs: "Mark Pine",
      date: "10/15/2008",
      address: "15 W. 7th Ave New York, NY"
    },
    {
      name: "Murphy Oil Corp",
      type: "60432",
      paymentInfo: "true",
      status: "neutral",
      standing: "$534,250",
      employees: "84",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Tania Oked",
      date: "09/28/2019",
      address: "65 W. 13rd St New York, NY"
    },
    {
      name: "Inspire Medical Systems Inc",
      type: "6286",
      paymentInfo: "true",
      status: "active",
      standing: "$53,450",
      employees: "39",
      officeType: "S-CORP",
      entityType: "S-CORP",
      execs: "Mack Guzin",
      date: "11/08/2009",
      address: "234 W. 3rd St New York, NY"
    },
    {
      name: "Iridium Communications Inc",
      type: "2064",
      paymentInfo: "true",
      status: "active",
      standing: "$257,359",
      employees: "15",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Kit Clou",
      date: "07/13/2017",
      address: "34 W. 43rd St New York, NY"
    },
    {
      name: "RBC Bearings Inc",
      type: "85027",
      paymentInfo: "true",
      status: "active",
      standing: "$925,762",
      employees: "64,523",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Suzan Tund",
      date: "09/18/2012",
      address: "134 W. East St New York, NY"
    },
    {
      name: "Kinsale Capital Group Inc",
      type: "81940",
      paymentInfo: "true",
      status: "active",
      standing: "$134,452",
      employees: "7,978",
      officeType: "C-CORP",
      entityType: "C-CORP",
      execs: "T Zhu",
      date: "08/28/2014",
      address: "14 W. 323rd St New York, NY"
    },
    {
      name: "Chart Industries Inc",
      type: "3058",
      paymentInfo: "true",
      status: "active",
      standing: "$350,000",
      employees: "474,978",
      officeType: "S-CORP",
      entityType: "S-CORP",
      execs: "Julie Ships",
      date: "01/08/1934",
      address: "534 W. 73rd St New York, NY"
    },
    {
      name: "BlackRock Cash Funds Treasury SL Agency",
      type: "2335",
      paymentInfo: "true",
      status: "active",
      standing: "$750,000",
      employees: "78",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Jang Types",
      date: "02/26/2004",
      address: "4 W. 6th Ave New York, NY"
    },
    {
      name: "ShockWave Medical Inc",
      type: "5930",
      paymentInfo: "true",
      status: "active",
      standing: "$350,000",
      employees: "978",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Ann Whirlz",
      date: "04/10/1993",
      address: "1234 W. 43rd St New York, NY"
    },
    {
      name: "Biohaven Pharmaceutical Holding Co Ltd",
      type: "4872 ",
      paymentInfo: "true",
      status: "active",
      standing: "$186,775",
      employees: "474,978",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Julie Ships",
      date: "06/17/2015",
      address: "56 W. 14th St New York, NY"
    },
    {
      name: "Intellia Therapeutics Inc",
      type: "6534",
      paymentInfo: "true",
      status: "active",
      standing: "$1,087,358",
      employees: "4,328",
      officeType: "S-CORP",
      entityType: "S-CORP",
      execs: "Reddy Goes",
      date: "01/08/1934",
      address: "4 W. 56th St New York, NY"
    },
    {
      name: "Chart Industries Inc",
      type: "76343 ",
      paymentInfo: "true",
      status: "active",
      standing: "$1,987,456",
      employees: "15",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Geo Clims",
      date: "05/13/2004",
      address: "785 W. 13th St New York, NY"
    },
    {
      name: "Karuna Therapeutics Inc",
      type: "6785",
      paymentInfo: "true",
      status: "active",
      standing: "$1,350,000",
      employees: "347",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Jun Pines",
      date: "01/08/1934",
      address: "A4 W. 67th St New York, NY"
    },
    {
      name: "Lattice Semiconductor Corp",
      type: "0943",
      paymentInfo: "true",
      status: "active",
      standing: "$1,050,000",
      employees: "74,431",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Mark Redds",
      date: "10/15/2008",
      address: "15 W. 7th Ave New York, NY"
    },
    {
      name: "Apellis Pharmaceuticals Inc",
      type: "9639",
      paymentInfo: "true",
      status: "neutral",
      standing: "$5,250",
      employees: "54",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Tanya Ok",
      date: "09/28/2019",
      address: "65 W. 13rd St New York, NY"
    },
    {
      name: "Ovintiv",
      type: "3787",
      paymentInfo: "true",
      status: "active",
      standing: "$50,000",
      employees: "78",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Matt Guz",
      date: "11/08/2009",
      address: "234 W. 3rd St New York, NY"
    },
    {
      name: "Antero Resources Group ",
      type: "6436",
      paymentInfo: "true",
      status: "active",
      standing: "$25,000",
      employees: "8",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Kat Skies",
      date: "07/13/2017",
      address: "34 W. 43rd St New York, NY"
    },
    {
      name: "Chesapeake Energy Corp.",
      type: "9753",
      paymentInfo: "true",
      status: "active",
      standing: "$850,000",
      employees: "74,978",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Suz Runz",
      date: "09/18/2012",
      address: "134 W. East St New York, NY"
    },
    {
      name: "Southwestern Energy Co. ",
      type: "0961",
      paymentInfo: "true",
      status: "active",
      standing: "$150,000",
      employees: "7,978",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Annie Payers",
      date: "08/28/2014",
      address: "14 W. 323rd St New York, NY"
    },
    {
      name: "Range Resources Corp. ",
      type: "6449",
      paymentInfo: "true",
      status: "active",
      standing: "$350,000",
      employees: "474,978",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Julie Ships",
      date: "01/08/1934",
      address: "534 W. 73rd St New York, NY"
    },
    {
      name: "BJ's Wholesale",
      type: "9470",
      paymentInfo: "true",
      status: "active",
      standing: "$750,000",
      employees: "78",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Jang Types",
      date: "02/26/2004",
      address: "4 W. 6th Ave New York, NY"
    },
    {
      name: "Avis Budget Group Inc",
      type: "3248",
      paymentInfo: "true",
      status: "active",
      standing: "$350,000",
      employees: "978",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Ann Whirlz",
      date: "04/10/1993",
      address: "1234 W. 43rd St New York, NY"
    },
    {
      name: "PDC Energy Inc",
      type: "5413 ",
      paymentInfo: "true",
      status: "active",
      standing: "$186,775",
      employees: "474,978",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Julie Ships",
      date: "06/17/2015",
      address: "56 W. 14th St New York, NY"
    },
    {
      name: "WillScot Mobile Mini Holdings Corp",
      type: "6534",
      paymentInfo: "true",
      status: "active",
      standing: "$1,087,358",
      employees: "4,328",
      officeType: "S-CORP",
      entityType: "S-CORP",
      execs: "Reddy Goes",
      date: "01/08/1934",
      address: "4 W. 56th St New York, NY"
    },
    {
      name: "Halozyme Therapeutics, Inc",
      type: "76343 ",
      paymentInfo: "true",
      status: "active",
      standing: "$1,987,456",
      employees: "15",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Geo Clims",
      date: "05/13/2004",
      address: "785 W. 13th St New York, NY"
    },
    {
      name: "Texas Roadhouse, Inc",
      type: "6785",
      paymentInfo: "true",
      status: "active",
      standing: "$1,350,000",
      employees: "347",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Jun Pines",
      date: "01/08/1934",
      address: "A4 W. 67th St New York, NY"
    },
    {
      name: "Matador Resources Company",
      type: "0943",
      paymentInfo: "true",
      status: "active",
      standing: "$1,050,000",
      employees: "74,431",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Mark Redds",
      date: "10/15/2008",
      address: "15 W. 7th Ave New York, NY"
    },
    {
      name: "Saia, Inc",
      type: "9639",
      paymentInfo: "true",
      status: "neutral",
      standing: "$5,250",
      employees: "54",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Tanya Ok",
      date: "09/28/2019",
      address: "65 W. 13rd St New York, NY"
    },
    {
      name: "RBC Bearings Inc",
      type: "3787",
      paymentInfo: "true",
      status: "active",
      standing: "$50,000",
      employees: "78",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Matt Guz",
      date: "11/08/2009",
      address: "234 W. 3rd St New York, NY"
    },
    {
      name: "Kinsale Capital Group Inc",
      type: "6436",
      paymentInfo: "true",
      status: "active",
      standing: "$25,000",
      employees: "8",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Kat Skies",
      date: "07/13/2017",
      address: "34 W. 43rd St New York, NY"
    },
    {
      name: "ChampionX Corp",
      type: "9753",
      paymentInfo: "true",
      status: "active",
      standing: "$850,000",
      employees: "74,978",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Suz Runz",
      date: "09/18/2012",
      address: "134 W. East St New York, NY"
    },
    {
      name: "SouthState Corp",
      type: "0961",
      paymentInfo: "true",
      status: "active",
      standing: "$150,000",
      employees: "7,978",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Annie Payers",
      date: "08/28/2014",
      address: "14 W. 323rd St New York, NY"
    },
    {
      name: "Agree Realty Corp",
      type: "6449",
      paymentInfo: "true",
      status: "active",
      standing: "$350,000",
      employees: "474,978",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Julie Ships",
      date: "01/08/1934",
      address: "534 W. 73rd St New York, NY"
    },
    {
      name: "Chord Energy Corp",
      type: "9470",
      paymentInfo: "true",
      status: "active",
      standing: "$750,000",
      employees: "78",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Jang Types",
      date: "02/26/2004",
      address: "4 W. 6th Ave New York, NY"
    },
    {
      name: "Glacier Bancorp Inc",
      type: "3248",
      paymentInfo: "true",
      status: "active",
      standing: "$350,000",
      employees: "978",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Ann Whirlz",
      date: "04/10/1993",
      address: "1234 W. 43rd St New York, NY"
    },
    {
      name: "ExlService Holdings Inc",
      type: "5413 ",
      paymentInfo: "true",
      status: "active",
      standing: "$186,775",
      employees: "474,978",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Julie Ships",
      date: "06/17/2015",
      address: "56 W. 14th St New York, NY"
    },
    {
      name: "Medpace Holdings Inc",
      type: "6534",
      paymentInfo: "true",
      status: "active",
      standing: "$1,087,358",
      employees: "4,328",
      officeType: "S-CORP",
      entityType: "S-CORP",
      execs: "Reddy Goes",
      date: "01/08/1934",
      address: "4 W. 56th St New York, NY"
    },
    {
      name: "Light & Wonder Inc",
      type: "76343 ",
      paymentInfo: "true",
      status: "active",
      standing: "$1,987,456",
      employees: "15",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Geo Clims",
      date: "05/13/2004",
      address: "785 W. 13th St New York, NY"
    },
    {
      name: "Murphy USA Inc",
      type: "6785",
      paymentInfo: "true",
      status: "active",
      standing: "$1,350,000",
      employees: "347",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Jun Pines",
      date: "01/08/1934",
      address: "A4 W. 67th St New York, NY"
    },
    {
      name: "Stag Industrial Inc",
      type: "0943",
      paymentInfo: "true",
      status: "active",
      standing: "$1,050,000",
      employees: "74,431",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Mark Redds",
      date: "10/15/2008",
      address: "15 W. 7th Ave New York, NY"
    },
    {
      name: "Commercial Metals Co",
      type: "9639",
      paymentInfo: "true",
      status: "neutral",
      standing: "$5,250",
      employees: "54",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Tanya Ok",
      date: "09/28/2019",
      address: "65 W. 13rd St New York, NY"
    },
    {
      name: "Crocs Inc",
      type: "3787",
      paymentInfo: "true",
      status: "active",
      standing: "$50,000",
      employees: "78",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Matt Guz",
      date: "11/08/2009",
      address: "234 W. 3rd St New York, NY"
    },
    {
      name: "ExlService Holdings Inc",
      type: "6436",
      paymentInfo: "true",
      status: "active",
      standing: "$25,000",
      employees: "8",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Kat Skies",
      date: "07/13/2017",
      address: "34 W. 43rd St New York, NY"
    },
    {
      name: "Murphy USA Inc",
      type: "9753",
      paymentInfo: "true",
      status: "active",
      standing: "$850,000",
      employees: "74,978",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Suz Runz",
      date: "09/18/2012",
      address: "134 W. East St New York, NY"
    },
    {
      name: "RBC Bearings Inc",
      type: "0961",
      paymentInfo: "true",
      status: "active",
      standing: "$150,000",
      employees: "7,978",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Annie Payers",
      date: "08/28/2014",
      address: "14 W. 323rd St New York, NY"
    },
    {
      name: "ChampionX Corp",
      type: "6449",
      paymentInfo: "true",
      status: "active",
      standing: "$350,000",
      employees: "474,978",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Julie Ships",
      date: "01/08/1934",
      address: "534 W. 73rd St New York, NY"
    },
    {
      name: "Chord Energy Corp",
      type: "9470",
      paymentInfo: "true",
      status: "active",
      standing: "$750,000",
      employees: "78",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Jang Types",
      date: "02/26/2004",
      address: "4 W. 6th Ave New York, NY"
    },
    {
      name: "Medpace Holdings Inc",
      type: "3248",
      paymentInfo: "true",
      status: "active",
      standing: "$350,000",
      employees: "978",
      officeType: "LLC",
      entityType: "LLC",
      execs: "Ann Whirlz",
      date: "04/10/1993",
      address: "1234 W. 43rd St New York, NY"
    },
  ],
};

export default companyData;
